
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","width":"16","height":"16","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","stroke":"#fff"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M5 2h2a1 1 0 01.117 1.993L7 4H5a1 1 0 00-.993.883L4 5v14a1 1 0 00.883.993L5 20h14a1 1 0 00.993-.883L20 19v-2a1 1 0 011.993-.117L22 17v2a3 3 0 01-2.824 2.995L19 22H5a3 3 0 01-2.995-2.824L2 19V5a3 3 0 012.824-2.995L5 2h2-2zm16 0l.081.003.12.017h0l.111.03h0l.111.044.098.052h0l.096.067.09.08h0l.097.112h0l.071.11.031.062h0l.034.081h0l.024.076h0l.03.148h0L22 3h0v6a1 1 0 01-2 0V5.414l-6.293 6.293a1 1 0 01-1.32.083l-.094-.083a1 1 0 01-.083-1.32l.083-.094L18.584 4H15a1 1 0 010-2h6z"}})])
          )
        }
      }
    